import {
  ScriptStepPermissionConfigOptionDef as ConfigOptionDef,
  ScriptStepPermissionDef as PermissionDef,
  ScriptStepSubjectDef as SubjectDef,
} from './scriptStepPermissionDef';

export const LIBRARY_NAME_MAX_LENGTH = 2000;
export const libraryUsagePermissionForm = 'libraryUsagePermissions';
export { ConfigOptionDef, PermissionDef, SubjectDef };
